module.exports = __webpack_public_path__ + "img/letters-preview-big.3bba5cea.svg";